import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import favouriteEquipmentAtom from '@/pages/User/atoms/favouriteEquipment.atom'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

const useFavoriteEquipment = () => {
  const equipmentList = useRecoilValue(equipmentAtom).items
  const favouriteEquipmentIds = useRecoilValue(favouriteEquipmentAtom).items

  const favouriteEquipment = useMemo(() => {
    return equipmentList.filter((eq) => favouriteEquipmentIds.includes(eq.id))
  }, [favouriteEquipmentIds, equipmentList])

  return favouriteEquipment
}

export default useFavoriteEquipment
